import { ErrorHandler } from '@angular/core';
export class UncaughtExceptionHandler implements ErrorHandler {
  handleError(error: any) {
    // JL().fatalException('Uncaught Exception', error);
    console.log(error);
  }
}
